module.exports = __webpack_public_path__ + "c1dba8625c978d998e7b38c89c729dc0.png";